import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import { apiUpdateUserAttributes, apiUpdateUserAvatar } from '../services/apis';
import * as actions from '../redux/editAccount';
import {
  getUserID,
  getIsProfileCompleted,
  getProfileCompletionMessage,
  getProfileInfo,
} from '@dragonfruit/redux/profile';

import { actions as errorActions } from '@dragonfruit/redux/error';
import { showAlertBanner } from '../redux/alertBanner';
import { showAlertModal } from '../redux/alertModal';

import { INVALID_WORD } from '@dragonfruit/constants/errorCode';
import { ALERT_ERROR_THEME } from '../constants/alertBannerThemes';
import i18n from '@dragonfruit/i18n';

import { updateUserProfileInfo, afterUpdateUserProfile } from './profile';

export function* editAccount(action) {
  const { data, showBannerAfterSuccess } = action.payload;
  const userId = yield select(getUserID);
  try {
    if (
      Object.getOwnPropertyNames(data).length === 0 &&
      !(data instanceof FormData)
    ) {
      yield put(actions.editAccountSuccess());

      return;
    }

    const response = yield call(apiUpdateUserAttributes, {
      userId,
      data,
    });

    yield put(actions.editAccountSuccess());

    if (!showBannerAfterSuccess) return;

    const isProfileCompleted = yield select(getIsProfileCompleted);
    const profileCompletionMessage = yield select(getProfileCompletionMessage);

    yield call(updateUserProfileInfo, response);

    yield afterUpdateUserProfile(
      isProfileCompleted,
      'account.updateAttributesSuccess',
      profileCompletionMessage
    );
  } catch (err) {
    const { error_code, message } = err;

    yield put(actions.editAccountFailure(message));

    if (error_code === INVALID_WORD) {
      yield put(
        showAlertModal({
          description: message,
          closeButtonText: i18n.t(
            'tutorSignup:tutorVerification.inAppropriateModal.ctaBtnText'
          ),
        })
      );
      return;
    }

    yield put(
      showAlertBanner({
        message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export function* updateTutorAvatarFlow(action) {
  const { blob, isDefaultAvatar } = action.payload;
  const userId = yield select(getProfileInfo, 'userId');

  try {
    const data = new FormData();
    data.append('new_profile_pic', blob);

    yield call(apiUpdateUserAvatar, {
      userId,
      data,
      isDefaultAvatar,
    });

    yield put(actions.updateTutorAvatarSuccess());
  } catch (err) {
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
    yield put(actions.updateTutorAvatarFailure(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([
    takeLatest(actions.EDIT_ACCOUNT, editAccount),
    takeLatest(actions.UPDATE_TUTOR_AVATAR, updateTutorAvatarFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/editAccount.js